const isFiniteNumber = (value) =>
  typeof value === "number" && Number.isFinite(value);

const buildToolbarMetric = ({
  marketPrice,
  marketPriceIsLoading,
  currencySymbol,
  pricePrecision,
}) => {
  const emptyChangeLabel = `${currencySymbol}-- (--%)`;
  if (marketPriceIsLoading) {
    return {
      heroMetric: "--",
      changeLabel: emptyChangeLabel,
      changeTone: "badge",
    };
  }

  if (isFiniteNumber(marketPrice?.price)) {
    const heroMetric = `${currencySymbol}${marketPrice.price.toFixed(pricePrecision)}`;

    if (!isFiniteNumber(marketPrice?.previousPrice)) {
      return { heroMetric, changeLabel: emptyChangeLabel, changeTone: "badge" };
    }

    const change = marketPrice.price - marketPrice.previousPrice;
    const absoluteChange = `${change >= 0 ? "+" : ""}${currencySymbol}${change.toFixed(
      pricePrecision,
    )}`;

    const changePctRaw =
      marketPrice.price !== 0
        ? (100 * change.toFixed(pricePrecision)) /
          marketPrice.price.toFixed(pricePrecision)
        : null;
    const changePct = isFiniteNumber(changePctRaw)
      ? `${changePctRaw >= 0 ? "+" : ""}${changePctRaw.toFixed(2)}%`
      : null;
    const changeLabel = changePct
      ? `${absoluteChange} (${changePct})`
      : absoluteChange;

    const changeTone =
      change.toFixed(pricePrecision) > 0
        ? "positive"
        : change.toFixed(pricePrecision) < 0
          ? "negative"
          : "neutral";

    return { heroMetric, changeLabel, changeTone };
  }
  return {
    heroMetric: "--",
    changeLabel: emptyChangeLabel,
    changeTone: "neutral",
  };
};

const MarketDataPriceIndicator = ({
  marketPrice,
  marketPriceIsLoading,
  currencySymbol,
  pricePrecision,
  title,
  variant,
}) => {
  const toolbarMetric = buildToolbarMetric({
    marketPrice,
    marketPriceIsLoading,
    currencySymbol,
    pricePrecision,
  });

  return (
    <div className="market-chart-panel market-data-price-indicator-panel">
      <h5 className="section-title">{title}</h5>
      <div className="market-data-price-indicator">
        <div className="market-chart-summary">
          <div className="market-chart-hero-row">
            <div className="market-chart-hero">{toolbarMetric.heroMetric}</div>
            <span
              className={`market-chart-change-badge ${toolbarMetric.changeTone} ${variant}`}
            >
              {toolbarMetric.changeLabel}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketDataPriceIndicator;
